import { useRef, useState } from 'react';
import { useSwipe } from '@/shared/hooks/useSwipe';
import MobileTransactionCard from './MobileTransactionCard';

export default function SwipeableTransactionCard({
  transaction, onEdit, onDelete, onSplit, onDeleteAllSplits, deleteTxId, setDeleteTxId, incomeList, currency, theme, anomalyMap = new Map(),
}) {
  const cardRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  const { deltaX, swiping, reset } = useSwipe(cardRef, {
    threshold: 80,
    onSwipeLeft: () => setRevealed(true),
  });

  const handleDeleteTap = () => {
    setDeleteTxId(transaction.id);
    reset();
    setRevealed(false);
  };

  const handleTapCard = () => {
    if (revealed) {
      reset();
      setRevealed(false);
    }
  };

  const translateX = revealed ? -80 : deltaX;

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Delete background */}
      <div
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: 80,
          background: '#ef4444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        <button
          onClick={handleDeleteTap}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontWeight: 700,
            fontSize: 13,
            cursor: 'pointer',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
          }}
          aria-label="Delete transaction"
        >
          <span style={{ fontSize: 18 }}>{'\u{1F5D1}'}</span>
          Delete
        </button>
      </div>

      {/* Sliding card */}
      <div
        ref={cardRef}
        onClick={handleTapCard}
        style={{
          position: 'relative',
          background: theme.cardBg,
          transform: `translateX(${translateX}px)`,
          transition: swiping ? 'none' : 'transform 0.3s ease',
          willChange: 'transform',
          padding: '0 4px',
        }}
      >
        <MobileTransactionCard
          transaction={transaction}
          onEdit={onEdit}
          onDelete={onDelete}
          onSplit={onSplit}
          onDeleteAllSplits={onDeleteAllSplits}
          deleteTxId={deleteTxId}
          setDeleteTxId={setDeleteTxId}
          incomeList={incomeList}
          currency={currency}
          theme={theme}
          anomalyMap={anomalyMap}
        />
      </div>
    </div>
  );
}
